export interface IDetailItemChange {
    detailId: number;
    itemId: number;
    text: string;
}
export interface IDetailItemMove {
    detailId: number;
    itemId: number;
}

export interface IDetailType {
    id: number;
    name: string;
}

export const DETAIL_TYPES: IDetailType[] = [
    { id: 1, name: 'Team Info' },
    { id: 2, name: 'Target Prospects' },
    { id: 3, name: 'Qualifying Questions' },
    { id: 4, name: 'Testimonials' },
];
